<template>
  <v-app>
    <v-main>
      <div style="width: 100%; max-width: 100%; padding: 15px">
        <div v-show="pageType == 'corporate'">
          <Corporate
            :linkParams="linkParams"
            :data="data"
            @corporateEmit="dataFromCorporate($event)"
          />
        </div>

        <div v-show="pageType == 'serii'">
          <Serii
            :linkParams="linkParams"
            :data="data"
            @seriiEmit="dataFromSerii($event)"
          />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Corporate from "./components/Corporate.vue";
import Serii from "./components/Serii.vue";
export default {
  name: "App",

  components: {
    Corporate,
    Serii,
  },

  data: () => ({
    pageType: "",
    linkParams: {},
    data: "", // date din B2B catre Serii/Corporate

    developer: "",
  }),

  methods: {
    dataFromSerii(event) {
      console.log("[data(EMIT) from Serii to & in AppVue]:", event);
      parent.postMessage(event, "*");
    },

    dataFromCorporate(event) {
      console.log("[data(EMIT) from Corporate to & in AppVue]:", event);
      parent.postMessage(event, "*");
    },

    async messageFromB2B(event) {
      // MESSAGE SERII START

      // send [j_model, t_model, w_model] from B2B to <Serii>
      if (event.data.type == "serieSend") {
        console.log(
          "%cMSG [B2B data to SERII]*event*",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );

        if ("tempcorpo" in event.data) {
          this.data = {
            type: event.data.type, // serieSend
            data: event.data.tempcorpo,
          };
          this.pageType = "serii";
        }
      }

      if (event.data.type == "serieSave") {
        console.log(
          "%cMSG [B2B Save SERII]*event*",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );

        this.data = {
          type: event.data.type, // serieSave
          data: event.data.orderid,
        };
      }

      if (event.data.type == "serieGet") {
        console.log(
          "%cMSG [B2B Get SERII]*event",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );
        // trimit 'serieGet' la <Serii>, care va trimite event cu date,
        // procesate ulterior in [dataFromSerii]

        this.data = {
          type: event.data.type, // serieGet
          data: "", // clear old data
        };

        // this.pageType = "serii"; // merge si fara, poate nici nu trebuie
      }
      // MESSAGE SERII END

      //\_/\_/\_/\_/\_/\_/\_/\_/\

      // MESSAGE CORPORATE START

      // send [j_model, j_sizeArray ...] from B2B to <Corporate>
      if (event.data.type == "corporateSend") {
        // console.log("\x1b[35m%s", "MSG [B2B Send CORPORATE]", event.data);
        console.log(
          "%cMSG [B2B Send CORPORATE]*event*",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );

        if ("tempcorpo" in event.data) {
          this.data = {
            type: event.data.type, // corporateSend
            data: event.data.tempcorpo,
          };
          this.pageType = "corporate";
        }
      }

      if (event.data.type == "corporateSave") {
        // console.log("\x1b[35m%s", "MSG [B2B Save CORPORATE]", event.data);
        console.log(
          "%cMSG [B2B Save CORPORATE]*event*",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );

        this.data = {
          type: event.data.type, // corporateSave
          data: event.data.orderid,
        };
      }

      if (event.data.type == "corporateGet") {
        // console.log("\x1b[35m%s", "MSG [B2B Get Corporate]", event.data);
        console.log(
          "%cMSG [B2B Get Corporate]*event*",
          "color:red; background-color:cyan; font-size:14px;",
          event.data
        );

        // trimit 'corporateGet' la <Corporate>, care va trimite event cu date,
        // procesate ulterior in [dataFromCorporate]

        this.data = {
          type: event.data.type, // corporateGet
          data: "", // clear old data
        };

        // this.pageType = "corporate"; // merge si fara, poate nici nu trebuie
      }
      // MESSAGE CORPORATE END
    },
  },

  created() {
    console.log(
      `%c[App Corpo/Serii Created]`,
      "color:yellow;background-color:blue;font-size:14px"
    );
    // console.log("\x1b[33m%s", "[App Corpo/Serii Created]");

    let params = {};
    let querystring = window.location.search;
    // console.log("[queryString]:", querystring);
    let searchParams = new URLSearchParams(querystring);

    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    this.linkParams = params;

    // this.linkParams.corporate = "serii"; // ?????????????????
    //  mai primesc aici si 'language' && 'readonly'
    // ?language=en&readonly=1
    console.log("[linkParams]:", this.linkParams);

    addEventListener("message", this.messageFromB2B, false);

    this.developer = process.env.NODE_ENV;
  },
};
</script>
